import { render } from "./AddToCartIconComponent.vue?vue&type=template&id=ac5641f6&scoped=true"
import script from "./AddToCartIconComponent.vue?vue&type=script&lang=js"
export * from "./AddToCartIconComponent.vue?vue&type=script&lang=js"

import "./AddToCartIconComponent.vue?vue&type=style&index=0&id=ac5641f6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5641f6"]])

export default __exports__